import React, { useState } from "react";
import { IconButton } from "@material-ui/core";
import TuneIcon from "@material-ui/icons/Tune";
import DialogLlmSettings from "./DialogLlmSettings";

export default function ButtonLlmSettings({ product, project_id, reloadData }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!product) return null;

  return (
    <>
      <IconButton
        size="small"
        onClick={() => setIsDialogOpen(true)}
        title="LLM settings"
        alt="LLM settings"
      >
        <TuneIcon fontSize="small" />
      </IconButton>
      <DialogLlmSettings
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        product={product}
        project_id={project_id}
        reloadData={reloadData}
      />
    </>
  );
}
